export const BACKEND = process.env.REACT_APP_BACKEND_URL || '';

export function api(path: string, method = 'GET', body?: any) {
  const token = localStorage.getItem('k3s_token') || '';
  return fetch(`${BACKEND}${path}`, {
    method,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: body ? JSON.stringify(body) : undefined,
  }).then(r => r.json());
}
